<template>
  <div class="yourdetails-banner">
    <div class="yourdetails-banner__heading">
      <h1 class="yourdetails-banner__heading--desktop">{{ headline }}</h1>
      <h1 class="yourdetails-banner__heading--mobile">{{ headline_mobile }}</h1>
      <p v-if="subheadline">
        {{ subheadline }}
      </p>
    </div>
  </div>
</template>

<script>
import { useBrand } from '@/composables/useBrand';
import md5 from 'js-md5';

export default {
  name: "YourDetailsBanner",
  props: {
    headline: undefined,
    headline_mobile: undefined,
    subheadline: undefined,
    lang: String,
    translations: Object,
    brandSlug: String
  },
  setup() {
    const { getBrandText, hasSpecialFeature } = useBrand();
    return { getBrandText, hasSpecialFeature };
  },
  data() {
    return {
      brandConfig: null
    };
  },

  methods: {
    getrans(key, fallback = '') {
      const brandId = this.brandSlug || 'DEFAULT';
      const lang = this.lang || 'en';
      const compositeKey = `${brandId}_${lang}_${key}`;
      const hashedKey = md5(compositeKey);
      return this.translations?.[hashedKey] || fallback;
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";
.yourdetails-banner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }

  &__heading {
    color: #ffffff;

    h1 {
      font-size: 1.375rem;
      font-weight: 700;
    }

    p {
      font-size: 1.16rem;
      font-weight: 600;
    }

    &--desktop {
      display: none;
      @media screen and (min-width: 960px) {
        display: block;
      }
    }

    &--mobile {
      font-size: 1rem;
      display: block;
      @media screen and (min-width: 960px) {
        display: none;
      }
    }

    @media screen and (min-width: 768px) {
      h1 {
        font-size: 1.875rem;
        margin-top: 0;
      }

      p {
        font-size: 1.375rem;
        margin-bottom: 0;
      }
    }
  }
}
</style>
